import { render, staticRenderFns } from "./ReAssignInsolvencyApplication.vue?vue&type=template&id=48c9c3a3&scoped=true&"
import script from "./ReAssignInsolvencyApplication.vue?vue&type=script&lang=js&"
export * from "./ReAssignInsolvencyApplication.vue?vue&type=script&lang=js&"
import style0 from "./ReAssignInsolvencyApplication.vue?vue&type=style&index=0&id=48c9c3a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c9c3a3",
  null
  
)

export default component.exports